import type { FileResponseV2 } from '@emma/api_client/types';
import { Text } from '@lego/klik-ui';
import { CopyableText } from '@/components/common/CopyableText';
import { createColumnHelper } from '../appTable';
import { dateRange } from '../filters/filterFunctions';

const columnHelper = createColumnHelper<FileResponseV2>();

export const deploymentFileTable = columnHelper.columns([
  columnHelper.accessor('id', {
    cell: (info) => (
      <Text fontFamily="mono" fontSize="sm">
        {info.getValue()}
      </Text>
    ),
    filterFn: 'includesString',
    header: 'ID',
    meta: { filterVariant: { constraint: /^[0-9]*$/, type: 'singleSearch' } },
    size: 96,
  }),
  columnHelper.accessor('fileName', {
    cell: (info) => info.getValue(),
    header: 'Name',
    filterFn: 'includesString',
    meta: { filterVariant: { type: 'singleSearch' } },
  }),
  columnHelper.accessor('digest', {
    cell: (info) => (
      <CopyableText
        copyLabel="Copy full value"
        prefixLength={8}
        suffixLength={8}
        textProps={{ fontFamily: 'mono', fontSize: 'sm' }}
        truncationMode="prefixSuffix"
        value={info.getValue()}
      />
    ),
    enableSorting: false,
    header: 'Digest',
  }),
  columnHelper.accessor('createdAt', {
    cell: (info) => info.getValue(),
    header: 'Created At',
    filterFn: dateRange,
    meta: { filterVariant: { type: 'dateRange' } },
  }),
  columnHelper.accessor('updatedAt', {
    cell: (info) => info.getValue(),
    header: 'Updated At',
    filterFn: dateRange,
    meta: { filterVariant: { type: 'dateRange' } },
  }),
  columnHelper.accessor('isDisabled', {
    cell: (info) => info.getValue(),
    header: 'Disabled',
    filterFn: 'equals',
    meta: {
      filterVariant: {
        type: 'singleSelect',
        options: [
          { name: 'Disabled', filterValue: true },
          { name: 'Not Disabled', filterValue: false },
        ],
      },
    },
  }),
]);
